import React from "react";
import { Provider } from "react-aria-components";

import { ServerCmsModelsSettingsFooterFooterPreviewTemplate } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../../Clickables";
import { H, HLevel } from "../../Headings";
import { Logo } from "../../Logo";
import { RichText } from "../../RichText";
import { SocialIcons, Socials } from "../../SocialIcons";
import { clickTrackingValues } from "../clickTrackingValues";
import { NewsletterForm } from "./NewsletterSignup";

import clickableStyles from "../../Clickables/index.module.scss";
import styles from "./Footer.module.scss";

export const Footer = ({
    value,
    socials,
}: {
    value: ServerCmsModelsSettingsFooterFooterPreviewTemplate["model"];
    socials: Socials;
}) => (
    <Provider values={clickTrackingValues("nav")}>
        <footer className={styles.root} data-track-section="footer">
            <Logo className={styles.logo} />
            <div className={styles.newsletterAndBlurb}>
                <RichText
                    value={value.blurb.value}
                    blockOverrides={{
                        unstyled: {
                            element: "p",
                            props: {
                                className: styles.blurb,
                            },
                        },
                    }}
                />
                <HLevel>
                    <H className={styles.newsletterTitle}>
                        {value.newsletter_title}
                    </H>
                    <NewsletterForm
                        intro={
                            <RichText
                                value={value.newsletter_intro.value}
                                blockOverrides={{
                                    unstyled: {
                                        element: "p",
                                        props: {
                                            className: styles.newsletterBody,
                                        },
                                    },
                                }}
                            />
                        }
                        success={
                            <RichText
                                value={value.newsletter_success.value}
                                blockOverrides={{
                                    unstyled: {
                                        element: "p",
                                        props: {
                                            className: styles.newsletterBody,
                                        },
                                    },
                                }}
                            />
                        }
                    />
                </HLevel>
            </div>
            <ul
                className={styles.linkGrid}
                style={{ "--columns": String(value.link_grid.value.length) }}
            >
                {value.link_grid.value.map((col) => (
                    <li key={col.id}>
                        <ul>
                            {col.value.map((item) => (
                                <li key={item.id}>
                                    {item.type === "link" ? (
                                        <Clickable simpleLink={item.value} />
                                    ) : (
                                        (item.value satisfies string)
                                    )}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
            <div className={styles.legal}>
                <ul className={styles.legalLinks}>
                    {value.legal_links.value.map((entry) => (
                        <li key={entry.id}>
                            {entry.type === "link" ? (
                                <Clickable simpleLink={entry.value} />
                            ) : entry.type === "cookie" ? (
                                <Clickable
                                    className={concatClassNames([
                                        "cky-banner-element",
                                        clickableStyles.base,
                                    ])}
                                >
                                    {entry.value}
                                </Clickable>
                            ) : (
                                (entry.type satisfies "text", entry.value)
                            )}
                        </li>
                    ))}
                </ul>
                <RichText
                    value={value.legal_text.value}
                    blockOverrides={{
                        unstyled: {
                            element: "p",
                            props: {
                                className: styles.legalText,
                            },
                        },
                    }}
                />
            </div>
            <SocialIcons socials={socials} className={styles.social} />
        </footer>
    </Provider>
);
